import {
  ReduxFindByIdNorm,
  ReduxInsert,
  ReduxRemove,
  ReduxFind,
  dbReducer,
  ReduxUpdate,
  ReduxFindAll,
} from '@weblite/persist'
import { HallInviteLink } from './types'

const COLLECTION = 'hallInviteLinks'

export const hallInviteLinkStorage = {
  del(id: string) {
    ReduxRemove(COLLECTION, { id })
  },

  deleteAllRevoked() {
    ReduxRemove(COLLECTION, { isRevoked: true })
  },

  get(id: string): HallInviteLink {
    return ReduxFindByIdNorm(COLLECTION, id)
  },

  getHallInviteLinks(roomId: string): HallInviteLink[] {
    return ReduxFind(COLLECTION, { roomId })
  },

  update(id: string, patch: Partial<HallInviteLink>) {
    ReduxUpdate(
      COLLECTION,
      { id },
      {
        $set: {
          ...patch,
        },
      },
    )
  },

  add(inviteLinks: HallInviteLink[]) {
    const allLinks: HallInviteLink[] = ReduxFindAll(COLLECTION)
    const newLinks = inviteLinks.filter(
      link => !allLinks.find(l => l.id === link.id),
    )
    ReduxInsert(COLLECTION, newLinks)
  },
}

export const hallInviteLinksReducer = dbReducer(['main', COLLECTION])
